import axios from 'axios';
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import LabOpportunities from './mylabspaces/LabOpportunities';
import { X } from 'lucide-react';
import LabPublications from './mylabspaces/LabPublications';
import { toast } from 'react-toastify';
import ChatModal from '../../Univeristy/labhead/ChatModal';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const MyLabSpaces=()=>{
  const navigate = useNavigate()
  const [labspace,setlabspace]=useState()
  const [search, setSearch] = useState("")
  const [isModalOpen,setIsAddModalOpen] = useState(false)
  const [params,setParams]=useState({})
  const [open,setOpen] = useState(false)
  const [groupName,setGroupName] = useState("")
  const [groupId,setGroupId] = useState("")

  useEffect(()=>{
     const CheckLabSpaceStatus=async()=>{
          try {
            const response=await axios.get(`${BASE_URL}/marketplace/researcher/labspace-status/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        })
        // console.log("The response is:",response?.data)
        const data=response?.data
        setlabspace(data)
          } catch (error) {
             console.log("Error while checking status of lab",error)
             toast.error(error.code)
          }
     }
     CheckLabSpaceStatus()
  },[])
  


  return (
    <>
    <div className="p-0 md:p-6 w-full mx-auto">
        <div className="flex items-center gap-3 mb-6">
    <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
      <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    </div>
    <div>
      <h1 className="text-lg md:text-2xl font-bold text-gray-900">Groups On Behalf Of University Lab</h1>
      <p className="text-sm text-gray-500 mt-1">
        You are member of these universities labs. You can publish research and share opportunities on behalf of the university lab.
      </p>
    </div>
  </div>

  {/* Search and Add Bar */}
  {
     labspace?.length > 0 &&  
      <div className="w-full flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
  {/* Search Input */}
  <div className="relative flex-1 w-full">
    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>
    <input
      type="text"
      placeholder="Search by name or email..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>
</div>
  }
 
  <div className="grid md:grid-cols-2 gap-6">
  {!labspace ? (
    // Loader
    <div className="w-full flex justify-center items-center h-32">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
    </div>
  ) : labspace.length === 0 ? (
    // No publications
    <div className="w-full text-center text-gray-500 py-10">
        You are not a part of any university lab  or You have not any labspace until now
    </div>
  ) : (
    labspace?.filter(item => !search || item.university_name.toLowerCase().includes(search.toLowerCase())).map((item, index) => (
      <div
        key={index}
        className="p-3 bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-md transition-all duration-200 flex flex-col"
      >
        {/* Person Info */}
        <div className="mb-4">
          <h2 className="text-lg font-bold text-gray-900 mb-2">
            {item?.university_name}
          </h2>
          <p className="mr-2 inline-block text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
            {item?.department_name}
          </p>
          <p className="inline-block text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
            {item?.lab_name}
          </p>
        </div>

        {/* Groups */}
        <div className="grid grid-cols-1 gap-3">
          {item.groups.map((g, i) => (
            <div key={i} className="border rounded-lg p-3 text-center">
              <button
  onClick={()=>{
    setOpen(true);
    setGroupName(g?.group_name);
    setGroupId(g?.group_id)
  }}
  className="px-3 py-2 bg-[#0f6abf] whitespace-nowrap text-white text-xs font-medium rounded-lg hover:bg-[#0a5ca8] transition-colors flex items-center gap-1"
>
  {/* Chat Icon */}
  <svg
    className="w-3.5 h-3.5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4-.8L3 20l1.2-3.6A7.962 7.962 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
    />
  </svg>

  Chat
</button>
              <img
                src={g.group_logo}
                alt={g.group_name}
                className="w-10 h-10 mx-auto mb-2 rounded-full"
              />
              <p className="font-bold text-sm">{g.group_name}</p>
              <p className="text-xs text-gray-500">{g.description}</p>
              <div className="flex flex-col md:flex-row gap-2 mt-4">
                <button onClick={() => {
  setParams({university_id:item?.university_id,department_id:item?.department_id,lab_id:item?.lab_id,group_id:g?.group_id});
  setIsAddModalOpen(true);
}} className="flex items-center justify-center gap-2 px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                  Create Publication
                </button>
                <button onClick={()=>navigate('/marketplace/independent_researcher/dashboard/mylabspaces/createlabopportunity',{state:{university_id:item?.university_id,department_id:item?.department_id,lab_id:item?.lab_id,group_id:g?.group_id}})} className="flex items-center justify-center gap-2 px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 4v16m8-8H4"
                    />
                  </svg>
                  Create Opportunity
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    ))
  )}
</div>

 <div className="grid md:grid-cols-2 gap-6 mt-6 ">
  {
        labspace?.length > 0 &&  
        <div  className="p-3 bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-md transition-all duration-200 flex flex-col">
      <LabPublications/>
    </div>
        
      }

    {
        labspace?.length > 0 && 
        <div  className="p-3 bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-md transition-all duration-200 flex flex-col">
         <LabOpportunities/>
    </div>
      
       }
    
 </div>
  {isModalOpen && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    {/* Modal Content */}
                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-xl relative"> 
                        {/* Header */}
                        <div className="relative p-6 border-b border-gray-100">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                                        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                        </svg>
                                    </div>
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-900">Upload Publications On Behalf Of University</h2>
                                        <p className="text-sm text-gray-500 mt-0.5">Manage and track all your research publications in one place</p>
                                    </div>
                                </div>
                                <button
                                    onClick={()=>setIsAddModalOpen(false)}
                                    className="absolute top-6 right-4 w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
                                >
                                    <X size={20} className="text-gray-500" />
                                </button>
                            </div>
                        </div>
                         <div className="p-6">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <button onClick={() => navigate("/marketplace/independent_researcher/dashboard/mylabspaces/add_lab_theoreticalidea",{state:{university_id:params?.university_id,department_id:params?.department_id,lab_id:params?.lab_id,group_id:params?.group_id}})} className="px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Add Theoretical Idea
          </button>
          <button onClick={() => navigate("/marketplace/independent_researcher/dashboard/mylabspaces/add_uni_lab_experiment",{state:{university_id:params?.university_id,department_id:params?.department_id,lab_id:params?.lab_id,group_id:params?.group_id}})}  className="px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Add Lab Experiment
          </button>
          <button onClick={() => navigate("/marketplace/independent_researcher/dashboard/mylabspaces/add_lab_prototype",{state:{university_id:params?.university_id,department_id:params?.department_id,lab_id:params?.lab_id,group_id:params?.group_id}})}  className="px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Add Prototype
          </button>
          <button onClick={() => navigate("/marketplace/independent_researcher/dashboard/mylabspaces/add_lab_industrial_application",{state:{university_id:params?.university_id,department_id:params?.department_id,lab_id:params?.lab_id,group_id:params?.group_id}})}  className="px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Add Industrial Application
          </button>
        </div>
        </div>
                       </div> </div>
  )}
     </div>
     <ChatModal
  isOpen={open}
  onClose={() => setOpen(false)}
  groupName={groupName}
  groupId={groupId}
/>
     </>
  );
}


export default MyLabSpaces